export interface Theme {
  colors: {
    main: string;
    accent: string;
    dark: string;
    light: string;
    white: string;
    text: {
      primary: string;
      secondary: string;
      light: string;
    };
    background: {
      primary: string;
      secondary: string;
      tertiary: string;
    };
    border: string;
    error: string;
    success: string;
    warning: string;
  };
  fonts: {
    primary: string;
  };
  spacing: {
    xs: string;
    sm: string;
    md: string;
    lg: string;
    xl: string;
    xxl: string;
  };
  breakpoints: {
    mobile: string;
    tablet: string;
    desktop: string;
    wide: string;
  };
}

export const theme: Theme = {
  colors: {
    main: '#657455',
    accent: '#b8964a',
    dark: '#1e2418',
    light: '#bbcbab',
    white: '#f5f5f2',
    text: {
      primary: '#1e2418',
      secondary: '#657455',
      light: '#bbcbab',
    },
    background: {
      primary: '#ffffff',
      secondary: '#f5f5f2',
      tertiary: '#bbcbab',
    },
    border: '#bbcbab',
    error: '#d32f2f',
    success: '#388e3c',
    warning: '#f57c00',
  },
  fonts: {
    primary: "'Abel', sans-serif",
  },
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    xxl: '3rem',
  },
  breakpoints: {
    mobile: '480px',
    tablet: '768px',
    desktop: '1024px',
    wide: '1440px',
  },
};
